import { useCallback, useEffect, useRef, useState } from 'react';
import { useLazyGetGlobalSearch } from '../../../services/redux/api/searchApi';
import { debounce } from '../../../utils/perfomance-utils';

export function useGlobalSearch() {
  const [filterValue, setFilterValue] = useState<string>('');
  const [globalSearch, { data }] = useLazyGetGlobalSearch();
  const [showSearchResult, setShowSearchResult] = useState<boolean>(false);
  const searchRef = useRef();

  const fetchResults = useCallback(
    debounce((value) => {
      if (value) {
        globalSearch({ searchValue: value, limit: 5 });
      }
    }, 500),
    [],
  );

  useEffect(() => {
    if (filterValue) {
      fetchResults(filterValue);
    } else {
      setShowSearchResult(false);
    }
  }, [filterValue]);

  useEffect(() => {
    if (filterValue) {
      setShowSearchResult(!!data);
    }
  }, [data]);

  function onClickAway() {
    setShowSearchResult(false);
  }

  function onSearchClick() {
    if (filterValue && data) {
      setShowSearchResult(true);
    }
  }

  function onFilterValue(value: string) {
    setFilterValue(value);

    if (!value) {
      setShowSearchResult(false);
    }
  }

  function isShowSearchResult() {
    return (
      showSearchResult &&
      searchRef?.current &&
      data?.users?.length +
        data?.communities?.length +
        data?.exercises?.length >
        0
    );
  }
  return {
    data,
    filterValue,
    searchRef,
    isShowSearchResult,
    onClickAway,
    onSearchClick,
    onFilterValue,
  };
}
